export enum CoreTablePaginationStepEnum {
  START = 'start',
  END = 'end',
  BACK = 'back',
  FORWARD = 'forward',
  BACK_GROUP = 'back-group',
  FORWARD_GROUP = 'forward-group',
}
